/**
 * ONE Request UI API
 * Rest API definition for ONE Request UI. 
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: toannhanb7@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface OneRequest { 
    id?: number;
    name?: string;
    requestGroupId?: number;
    value?: string;
    directMgmts?: Array<string>;
    followers?: Array<string>;
    documents?: Array<string>;
    readonly status?: OneRequest.StatusEnum;
    readonly submitter?: string;
    approvers?: Array<string>;
    readonly submitTime?: number;
    readonly requestGroupName?: string;
    approveds?: Array<string>;
    readonly rejecteds?: Array<string>;
    readonly cancelleds?: Array<string>;
    readonly favorite?: boolean;
    readonly remainingTime?: number;
    readonly timeout?: number;
    readonly hasRequestForm?: boolean;
    readonly lastUpdated?: number;
    attrDocuments?: Array<string>;
    taskIds?: Array<number>;
    readonly ogId?: number;
    ogName?: string;
    visited?: boolean;
}
export namespace OneRequest {
    export type StatusEnum = 'PENDING' | 'CANCELLED' | 'TIMEOUT' | 'REJECTED' | 'REQUEST_UPDATE' | 'APPROVED' | 'CLOSED';
    export const StatusEnum = {
        PENDING: 'PENDING' as StatusEnum,
        CANCELLED: 'CANCELLED' as StatusEnum,
        TIMEOUT: 'TIMEOUT' as StatusEnum,
        REJECTED: 'REJECTED' as StatusEnum,
        REQUESTUPDATE: 'REQUEST_UPDATE' as StatusEnum,
        APPROVED: 'APPROVED' as StatusEnum,
        CLOSED: 'CLOSED' as StatusEnum
    };
}


